module.exports = __webpack_public_path__ + "bc37eb13226aede3c6e547ab629facf9.MP3";